module.exports = __webpack_public_path__ + "static/media/matt.8b976091.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/matt.png
// module id = 112
// module chunks = 0